export interface IIssueDeviceInfo {
  appCodeName: string
  appName: string
  appVersion: string
  cookieEnabled: boolean
  geolocation: Geolocation
  language: string
  languages: string[]
  platform: string
  product: string
  productSub: string
  userAgent: string
  vendor: string
  vendorSub: string
  screenWidth: number
  screenHeight: number
  simulation: boolean
}

export const convertNavigatorToJSON = (simulation: boolean) => {
  const nav = window.navigator
  const obj: IIssueDeviceInfo = {
    appCodeName: nav.appCodeName || '',
    appName: nav.appName || '',
    appVersion: nav.appVersion || '',
    cookieEnabled: nav.cookieEnabled,
    geolocation: nav.geolocation,
    language: nav.language || '',
    languages: [...nav.languages] || [],
    platform: nav.platform || '',
    product: nav.product || '',
    productSub: nav.productSub || '',
    userAgent: nav.userAgent || '',
    vendor: nav.vendor || '',
    vendorSub: nav.vendorSub || '',
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    simulation: simulation,
  }
  return JSON.stringify(obj)
}
